"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault"),
    _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react")),
    _classnames = _interopRequireDefault(require("classnames")),
    _Image = _interopRequireDefault(require("../../../../Image")),
    _Text = _interopRequireDefault(require("../../../../Text")),
    _userDetails = require("../styles/userDetails"),
    UserDetail = function UserDetail(a) {
  var b = a.userName,
      c = a.profileImage,
      d = a.children;
  return _react["default"].createElement("div", {
    className: (0, _classnames["default"])("user-details__container", _userDetails.USER_DETAILS_CONTAINER)
  }, _react["default"].createElement(_Image["default"], {
    imageUrl: c,
    placeholderText: b,
    placeholderTextSize: 13,
    width: "40px",
    height: "40px",
    defaultImageIcon: "user-profile-sq",
    circular: !0
  }), _react["default"].createElement("div", {
    className: (0, _classnames["default"])("user-details__name-container", _userDetails.CONTAINER)
  }, b && !b.includes("undefined") ? _react["default"].createElement(_Text["default"], {
    highlighted: !0,
    noMargin: !0
  }, b) : null, d));
},
    _default = (0, _react.memo)(UserDetail);

exports["default"] = _default;